class Pixxio {
    constructor(pixxiocomp) {
        // Settings
        this.formatsWithCropEnabled = true
        this.variantStacksEnabled = false

        if (pixxiocomp){
            this.comp = pixxiocomp
            this.zipNameAll = 'alleBilder.zip'
            this.zipNameSel = 'selektierteBilder.zip'
            this.activeDownloadsAll = 0
            this.activeDownloadsSel = 0

            this.init()
        }
    }

    async init() {
        this.comppath = this.comp.dataset.comppath

        const r = await fetch(this.comppath + '?ajax=true')
        let key = await r.text()
        this.token = 'Bearer ' + key.trim()
        // console.log('this.token')
        // console.log(this.token)
        // this.token = (this.comp.dataset.token) ? this.comp.dataset.token : 'Bearer jFVxWtLCZHDmnC9Lam8X59TBGkvF75bMJCmXR3s1EzVapfbw5H4p8vksHMDsJgkG'
        this.apiUrl = (this.comp.dataset.apiurl) ? this.comp.dataset.apiurl : 'https://sva-ag.px.media/api/v1'

        this.allFiles = []
        this.allIds = []
        this.allVariants = {}
        this.detailOptionsOpen = false

        this.container = this.comp.closest(".container")
        this.downAllBtn = this.container.querySelector(".download-all-btn")
        this.downSelBtn = this.container.querySelector(".download-selected-btn")
        this.downSelBtnCounter = this.downSelBtn.querySelector(".counter")
        this.selCounter = 0

        this.popup = this.container.querySelector(".popup-image")
        this.popupWrap = this.popup.querySelector(".popup-center-wrap")
        this.popupClose = this.popup.querySelector(".popup-close")
        this.popupPrev = this.popup.querySelector(".prev")
        this.popupNext = this.popup.querySelector(".next")
        this.popupMeta = this.popup.querySelector(".meta")
        this.detailDownBtn = this.popup.querySelector('.download-btn');

        this.downloadPrefix = (this.comp.dataset.prefix) ? this.comp.dataset.prefix : ''
        this.formats = this.comp.dataset.formats
        this.formatsWithCrop = {}
        this.keywords = this.comp.dataset.keywords
        this.collections = this.comp.dataset.collections
        // this.shares = this.comp.dataset.shares

        if (this.formats && this.formats.split(',').length > 0){
            this.fetchFormatsAndExpandOptions()
        }
        this.fetchFilesAndRender()
    }

    async fetchFormatsAndExpandOptions(){
        let u = `${this.apiUrl}/downloadFormats?responseFields=["id", "name", "height", "width", "maxSize", "formatConversion"]`

        //get format url
        const r = await fetch(u, {headers: {Authorization: this.token}})
        const d = await r.json()
        if (d && d.downloadFormats && d.downloadFormats.length){
            const selectedFormats = this.formats.split(',')
            this.container.querySelectorAll('.formats').forEach(vEl => {
                d.downloadFormats.forEach( format => {
                    if (selectedFormats.includes(format.id.toString())){
                        if (this.formatsWithCropEnabled && format.width && format.height) {
                            this.formatsWithCrop[format.id] = [format.width, format.height]
                            if (vEl.closest('.popup-image')){
                                vEl.insertAdjacentHTML('beforeend', `<div class="${format.id}">${format.name}<div class="loading-ring"></div></div>`)
                            }
                        } else {
                            vEl.insertAdjacentHTML('beforeend', `<div class="${format.id}">${format.name}<div class="loading-ring"></div></div>`)
                        }
                    }
                })
            })
        }
    }
    async fetchFilesAndRender(){
        //get collections and keywords
        if (this.collections || this.keywords) {
            this.allFiles = [...this.allFiles, ...await this.getCollectionsAndKeywords() ]
        }

        //get external shares
        // if (this.shares && this.shares.split(',').length > 1) {
        //     this.allFiles = [...this.allFiles, ...await this.getExternalShares() ]
        // }

        //remove duplicates
        const uniqueObjMap = {};
        for (const object of this.allFiles) {
            uniqueObjMap[object.id] = object;
        }
        this.allFiles = Object.values(uniqueObjMap);

        this.comp.classList.remove('loading')
        if (this.allFiles && this.allFiles.length) {
            this.initGrid()
        } else {
            // Check if we're on a public instance
            const isPublic = this.comp.dataset.isPublic === 'true'
            if (isPublic) {
                // Hide the entire component on public instances when no results
                const section = this.comp.closest('section')
                if (section) {
                    section.style.display = 'none'
                }
            } else {
                // Show no-results message on author/edit instances
                this.comp.classList.add('no-results')
            }
        }
    }
    async getCollectionsAndKeywords() {
        const response = await fetch( this.buildFilesGetUrl(), { headers: {Authorization: this.token} })
        if (!response.ok) {
            const message = `An error has occured: ${response.status}`;
            throw new Error(message);
        }

        const data = await response.json();
        // console.log('getCollectionsAndKeywords data')
        // console.log(data)

        this.keywords.pop()
        const files = data.files.filter(f => !f.keywords.includes("Archiv") && this.keywords.every(k => f.keywords.includes(k)) )
        return files
    }

    initGrid() {
        this.downAllBtn.disabled = false
        let fileCountExcludingVariants = 0

        let passedVariants = []
        //build images grid
        this.allFiles.forEach((f) => {
            this.allIds.push([f.name, f.id])
            let addToGrid = true
            let variantStackDataString = ''
            if ( this.variantStacksEnabled && f.variantStack && f.variantStack.id) {
                const vId = f.variantStack.id
                if (!(vId in this.allVariants)) this.allVariants[vId] = []
                this.allVariants[vId].push({'id': f.id, 'name':f.fileName})
                if (passedVariants.includes(vId)){
                    addToGrid = false
                } else {
                    passedVariants.push(vId)
                    variantStackDataString = ` data-variantid=${vId}`
                }
            }
            if (addToGrid){
                fileCountExcludingVariants++
                this.comp.insertAdjacentHTML('afterbegin', `
                  <div class="image" id="iwrap-${f.id}">
                    <input type="checkbox" id="${f.id}" name="${f.id}" value="${f.id}">
                    <img src="${f.previewFileURL}" data-previewsrc="${f.previewFileURL}" data-originalsrc="${f.originalFileURL}" data-height="${f.height}" data-filesize="${f.fileSize}" data-width="${f.width}"  data-name="${f.fileName}" data-id="${f.id}"${variantStackDataString} alt="${f.fileName}">
                  </div>`)
            }
        })
        // console.log('this.allVariants')
        // console.log(this.allVariants)

        this.downAllBtn.querySelector('.quantity').textContent = ` (${fileCountExcludingVariants})`

        //download all btn
        this.downAllBtn.onclick = () => {
            this.showDownloadOptions(this.downAllBtn, this.allIds, this.zipNameAll)
        }

        //download selection btn
        this.downSelBtn.onclick = () => {
            const selectedIds = this.collectSelectedIds()
            this.showDownloadOptions(this.downSelBtn, selectedIds, this.zipNameSel)
        }

        //hide formats on any click that is not a download btn
        this.comp.addEventListener('click', (event) => {
            if (!event.target.classList.contains('down-btn')) {
                this.hideOptions()
            }
        })

        //update selected counter on checkbox clicks
        this.comp.querySelectorAll('.image input[type=checkbox]').forEach(checkbox => { this.initCheckbox(checkbox) })

        //popup open
        this.comp.querySelectorAll(".image-container img").forEach(image =>{ this.initPopup(image) });

        //popup close
        this.popupClose.onclick = () => {
            this.popup.style.display = "none";
            this.popup.querySelector(".formats").style.display = "none";
        }
    }

    showVariantOptions(btn, vId) {
        let variants = btn.querySelector('.variants');
        if (variants) {
            variants.innerHTML = ''
            this.allVariants[vId].forEach(variant => {
                variants.insertAdjacentHTML('afterbegin', `<div class="${variant.id}">${variant.name}</div>`)
            })
            this.detailOptionsOpen = true
            variants.style.display = 'block'
            variants.childNodes.forEach(vEl => {
                vEl.onclick = async () => {
                    variants.style.display = 'none'
                    const vId = vEl.className
                    this.showDownloadOptions(btn, [[vEl.textContent, vId]])
                }
            })

            // variants.onmouseleave = () => {
            //     this.hideOptions()
            // }
        }
    }
    showDownloadOptions(btn, ids, name = "singleImage.jpg") {
        let formats = btn.querySelector('.formats');
        if (formats) {
            formats.style.display = 'block'
            formats.childNodes.forEach(fEl => {
                fEl.onclick = async () => {
                    if (!fEl.classList.contains('disabled')){
                        const format = fEl.className
                        fEl.classList.add('disabled')
                        await this.downloadImages(ids, fEl, format, name)
                        fEl.classList.remove('disabled')
                        this.hideOptions()
                    }
                }
            })

            formats.onmouseleave = () => {
                this.hideOptions()
            }
        }
    }
    hideOptions(){
        document.querySelectorAll('.formats, .variants').forEach( formats => {formats.style.display = 'none'})
        this.detailOptionsOpen = false
    }

    initCheckbox(checkbox) {
        checkbox.onclick = () => {
            if (checkbox.checked){
                this.selCounter++
                if (this.downSelBtn.disabled) {
                    this.downSelBtn.disabled = false
                }
            } else {
                this.selCounter--
                if (this.selCounter === 0 && !this.downSelBtn.disabled) {
                    this.downSelBtn.disabled = true
                }
            }
            this.downSelBtnCounter.textContent = `(${this.selCounter})`
        }
    }

    initPopup(image) {
        image.onclick = () => {
            this.updatePopupImage(image)
        }
    }
    updatePopupImage(image) {
        this.popup.style.display = "block";
        this.popupWrap.style.backgroundImage = `url(${image.getAttribute('src')})`
        this.popupWrap.dataset.id = image.dataset.id

        if ( this.variantStacksEnabled && image.dataset.variantid){
            this.detailDownBtn.onclick = () => {
                if (!this.detailOptionsOpen) {
                    this.showVariantOptions(this.detailDownBtn, image.dataset.variantid)
                }
            }
        } else {
            this.detailDownBtn.onclick = () => { this.showDownloadOptions(this.detailDownBtn, [[image.dataset.name, image.dataset.id]]) }
        }

        //btns nav
        this.updateNavBtn( this.getPrevNextPopupImage('previous', image), this.popupPrev )
        this.updateNavBtn( this.getPrevNextPopupImage('next', image), this.popupNext )

        this.popupMeta.textContent = `${image.dataset.width}x${image.dataset.height}px [${ (Math.round( image.dataset.filesize / 10000 ) / 100).toFixed(2) } MB]`

        //keyboard nav
        document.onkeydown = (e) => {
            switch (e.key) {
                case 'Escape':
                    this.popupClose.click()
                    break;
                case 'ArrowRight':
                    this.popupNext.click()
                    break;
                case 'ArrowLeft':
                    this.popupPrev.click()
                    break;
                default:
                    break;
            }
        };
    }
    updateNavBtn(image, btn){
        if (image) {
            btn.style.opacity = 1
            btn.style.cursor = 'pointer'
            btn.onclick = () => { this.updatePopupImage( image ) }
        } else {
            btn.style.opacity = 0
            btn.style.cursor = 'default'
        }
    }
    getPrevNextPopupImage(prevOrNext, image){
        const currentGridImageWrap = this.comp.querySelector(`#iwrap-${image.dataset.id}`)
        const nextImageWrap = currentGridImageWrap[prevOrNext + 'ElementSibling']
        if (nextImageWrap && nextImageWrap.classList.contains('image')) {
            const nextImage = nextImageWrap.querySelector('img')
            if (nextImage){
                return nextImage
            }
        }
        return false
    }

    calculateCropOffsets(imageWidth, imageHeight, cropWidth, cropHeight) {
        // Ensure crop dimensions are not larger than image dimensions
        if (cropWidth > imageWidth || cropHeight > imageHeight) {
            return {
                offsetX: 0,
                offsetY: 0
            }
        }

        // Calculate offsets for centered crop
        const offsetX = (imageWidth - cropWidth) / 2;
        const offsetY = (imageHeight - cropHeight) / 2;

        return {
            offsetX: Math.round(offsetX),
            offsetY: Math.round(offsetY)
        }
    }

    async getImageUrl(id, format){
        let u = `${this.apiUrl}/files/${id[1]}/convert?responseType=path&downloadType=`
        // let u = `${this.apiUrl}/files/${id[1]}/convert?responseType=binary&downloadType=`
        if (format === 'original'){
            u += `original`
        } else if (format === 'preview'){
            u += `custom&maxSize=1000`
        } else if (format in this.formatsWithCrop){
            // console.log('Format found in formatsWithCrop:', format);
            const [formatWidth, formatHeight] = this.formatsWithCrop[format];
            // console.log('Format dimensions:', { formatWidth, formatHeight });
            // console.log(this.allFiles);
            // console.log(id[1]);
            const file = this.allFiles.find(f => `${f.id}` === `${id[1]}`);

            if (file) {
                const originalWidth = Math.round(file.width);
                const originalHeight = Math.round(file.height);
                // console.log('Original dimensions:', { originalWidth, originalHeight });

                // Calculate aspect ratio of the format
                const formatAspectRatio = formatWidth / formatHeight;
                // console.log('Format aspect ratio:', formatAspectRatio);

                // Calculate crop dimensions that maintain the format's aspect ratio
                let cropWidth, cropHeight;

                if ((originalWidth / originalHeight) > formatAspectRatio) {
                    // Image is wider than format ratio - crop width
                    cropHeight = originalHeight;
                    cropWidth = Math.round( cropHeight * formatAspectRatio );
                } else {
                    // Image is taller than format ratio - crop height
                    cropWidth = originalWidth;
                    cropHeight = Math.round( cropWidth / formatAspectRatio );
                }

                // Calculate offsets to center the crop
                const xOffset = Math.round((originalWidth - cropWidth) / 2);
                const yOffset = Math.round((originalHeight - cropHeight) / 2);

                // console.log('Calculated values:', {
                //     format,
                //     formatAspectRatio,
                //     originalDimensions: { width: originalWidth, height: originalHeight },
                //     cropDimensions: { width: cropWidth, height: cropHeight },
                //     cropOffsets: { x: xOffset, y: yOffset }
                // });

                u += `custom&maxSize=${formatWidth}&crop={"width":${cropWidth},"height":${cropHeight},"offsetY":${yOffset},"offsetX":${xOffset}}`
            } else {
                console.log('File not found for ID:', id);
            }
        } else {
            u += `downloadformat&downloadFormatID=${format}`
        }

        //get url
        // console.log(u)
        const r = await fetch(u, {headers: {Authorization: this.token}})
        const json = await r.json()
        return json.downloadURL
    }

    async getZipUrl(ids, format, btn){
        let onlyIds = []
        ids.forEach( id => {
            onlyIds.push(id[1])
        })
        let u = `${this.apiUrl}/files/convert?downloadType=`
        if (format === 'original'){
            u += `original`
        } else if (format === 'preview'){
            u += `custom&maxSize=1000`
            // TODO: implement formatsWithCrop for multidown as soon as feedback from pixxio comes
        // } else if (format in this.formatsWithCrop){
        //     [w,h] = this.formatsWithCrop[format]
        //     u += `custom&maxSize=${h}&crop={"width":${w},"height":${h},"offsetY":100,"offsetX":100}`
        } else {
            u += `downloadformat&downloadFormatID=${format}`
        }
        u += `&ids=[${onlyIds.toString()}]`

        let r = await fetch(u, {headers: {Authorization: this.token}})
        let json = await r.json()
        const jobId = json.jobID

        const downloadURL = await new Promise(resolve => {
            const interval = setInterval(async () => {
                u = `${this.apiUrl}/jobs/${jobId}?responseFields=["id", "progress", "isFinished", "jobData"]`
                r = await fetch(u, {headers: {Authorization: this.token}})
                json = await r.json()
                btn.style.setProperty('--perc', `${json.job.percent * 0.5}%`);

                if (json.job.isFinished) {
                    resolve(json.job.finishedJobData.downloadURL)
                    clearInterval(interval)
                };
            }, 1000)
        })

        return downloadURL
    }

    async downloadImages( ids, btn, format, nameOfDownload = "singleImage.jpg") {
        let href;
        const originalBtnText = btn.textContent

        const isAllDown = (nameOfDownload === this.zipNameAll)
        const isSelDown = (nameOfDownload === this.zipNameSel)
        if (isAllDown) {
            this.activeDownloadsAll++
            this.downAllBtn.classList.add('has-downloads')
        }
        if (isSelDown) {
            this.activeDownloadsSel++
            this.downSelBtn.classList.add('has-downloads')
        }

        //start progress bar
        btn.classList.add('progress')
        btn.style.setProperty('--perc', '1%')

        if (ids.length > 1){
            //multiple images
            href = await this.getZipUrl(ids, format, btn)
        } else {
            //one image
            btn.style.setProperty('--perc', '30%')
            href = await this.getImageUrl(ids[0], format)
            btn.style.setProperty('--perc', '50%')
            nameOfDownload = ids[0][0]
        }

        const response = await fetch(href, {headers: {Authorization: this.token}})
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const contentLength = response.headers.get('content-length');
        const totalSize = contentLength ? parseInt(contentLength, 10) : 0;
        // create the stream
        const reader = response.body.getReader();
        const stream = new ReadableStream({
            async start(controller) {
                let loaded = 0;
                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;
                    loaded += value.length;
                    const progress = totalSize ? (loaded / totalSize) * 100 : 0;
                    btn.style.setProperty('--perc', `${50 + (progress * 0.5)}%`);
                    controller.enqueue(value);
                }
                controller.close();
            },
        });
        const responseStream = new Response(stream);
        // finish progress bar
        btn.style.setProperty('--perc', '100%');
        const blob = await responseStream.blob();

        btn.classList.remove('progress')
        href = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = this.addFormatToFilename(nameOfDownload, originalBtnText)
        link.click();
        link.remove()
        window.URL.revokeObjectURL(href)
        btn.textContent = originalBtnText

        if (isAllDown) {
            this.activeDownloadsAll--
            if (this.activeDownloadsAll === 0) this.downAllBtn.classList.remove('has-downloads')
        }
        if (isSelDown) {
            this.activeDownloadsSel--
            if (this.activeDownloadsSel === 0) this.downSelBtn.classList.remove('has-downloads')
        }
    }
    addFormatToFilename(filename, format){
        let dotIndex = filename.lastIndexOf(".");
        // console.log(format)
        const originalExtension = filename.substring(dotIndex)
        // console.log(originalExtension)
        const isOriginal = format === 'Original'
        const isZip = originalExtension === '.zip'
        const extension = ( isOriginal || isZip ) ? originalExtension : '.jpg'
        filename = filename.substring(0, dotIndex)
        filename = this.downloadPrefix + filename + '_' + format
        filename = filename.replace(/[^A-Za-z0-9_]+/gi, '-').replace(/^-|-$/g, '')
        // return concat.toLowerCase().replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '')
        return filename + extension
    }

    collectSelectedIds() {
        let selectedIds = []
        this.comp.querySelectorAll('.image input[type=checkbox]').forEach(checkbox => {
            if (checkbox.checked) {
                const img = checkbox.nextElementSibling
                selectedIds.push([img.dataset.name, img.dataset.id])
            }
        })
        // console.log(selectedIds)
        return selectedIds
    }

//     async getExternalShares(){
//         let files = []
//         console.log(this.shares)
//
//         this.shares = this.shares.split(',')
//         this.shares.pop()
//         console.log('this.shares')
//         console.log(this.shares)
//         if (this.shares) {
//
//             // run in parallel to increase speed
//             await Promise.all(this.shares.map(async (el) => {
//
//                 let url = `${this.apiUrl}/externalShares/${el}\
// ?responseFields=["id","name","collection","fileDetails","filesQuantity","expirationDate","securedWithPassword","downloadFormats"]\
// &collectionResponseFields=["id","name","previewFiles","filesQuantity"]\
// &collectionPreviewFilesLimit=9999\
// &collectionPreviewFilesResponseFields=["id","fileName","fileExtension","originalFileURL","previewFileURL"]`
//
//                 console.log(`fetching externalShare via ${url}`)
//
//                 const response = await fetch( url, { headers: {Authorization: this.token}})
//
//                 if (!response.ok) {
//                     const message = `An error has occured: ${response.status}`;
//                     throw new Error(message);
//                 }
//
//                 const data = await response.json()
//
//                 console.log('externalShare data')
//                 console.log(data)
//                 // console.log(el)
//                 console.log(`Quantity: ${data.externalShare.filesQuantity}`)
//                 console.log(data.externalShare.fileDetails)
//                 console.log(`Collection: ${data.externalShare?.collection}`)
//                 if (data.externalShare.collection?.previewFiles){
//                     const previewFiles = data.externalShare.collection.previewFiles
//                     console.log(previewFiles)
//                     files = [...files, ...previewFiles]
//                     // files.concat(previewFiles)
//
//                     console.log('files after concat')
//                     console.log(files)
//
//                     // this.allFiles.concat(previewFiles)
//                 }
//             }))
//         }
//
//         return files
//     }
    buildFilesGetUrl() {

        // TODO: find max pagesize or implement pagination
        // curl --location --globoff 'https://sukoa.px.media/api/v1/files?page=1&responseFields=["originalFileURL","previewFileURL","id","fileName"]&pageSize=40&sortBy=uploadDate&filter={"filterType":"collection","collectionID":"1395148777"}' --header 'Authorization: Bearer jFVxWtLCZHDmnC9Lam8X59TBGkvF75bMJCmXR3s1EzVapfbw5H4p8vksHMDsJgkG'
        // demo response:
        // {"success":true,"quantity":171,"files":[{"id":554472925,"fileName":"ipad.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fb0%2FB0UV6UodX2Wu7j39wU__1719826231_0695128.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fb0%2FB0UV6UodX2Wu7j39wU__1719826231_0695128.jpg&width=1920"},{"id":2107176808,"fileName":"IMG_6846.HEIC","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fia%2FIAcDEGBoeJrZrw1IeU__1719818578_2980287.heic","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fia%2FIAcDEGBoeJrZrw1IeU__1719818578_2980287.jpg&width=1920"},{"id":1655699084,"fileName":"IMG_6844.HEIC","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fnd%2FndBJRs6uTsPp9DhhlX__1719818578_3359498.heic","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fnd%2FndBJRs6uTsPp9DhhlX__1719818578_3359498.jpg&width=1920"},{"id":176000556,"fileName":"IMG_6845.HEIC","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fgi%2FgIEMze2gUM9jnFxOnj__1719818578_6827765.heic","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fgi%2FgIEMze2gUM9jnFxOnj__1719818578_6827765.jpg&width=1920"},{"id":86543484,"fileName":"IMG_6847.HEIC","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Frb%2Frb1viZI82f0CnMgNDW__1719818578_4014804.heic","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Frb%2Frb1viZI82f0CnMgNDW__1719818578_4014804.jpg&width=1920"},{"id":406259852,"fileName":"067A1932.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fvx%2FVxx5xoCzBIz4jHjiDL__1719300739_8519358.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fvx%2FVxx5xoCzBIz4jHjiDL__1719300739_8519358.jpg&width=1920"},{"id":1680953449,"fileName":"067A1928.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fbh%2FBHPlfEuT8Exp7yKK7D__1719300735_0808791.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fbh%2FBHPlfEuT8Exp7yKK7D__1719300735_0808791.jpg&width=1920"},{"id":1938181072,"fileName":"067A1927.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fvb%2FvbxTuuxbdJ0rEzImyD__1719300729_0342968.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fvb%2FvbxTuuxbdJ0rEzImyD__1719300729_0342968.jpg&width=1920"},{"id":1645177764,"fileName":"067A1921.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fco%2Fcof50PehLV3OJtw9sG__1719300727_1725587.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fco%2Fcof50PehLV3OJtw9sG__1719300727_1725587.jpg&width=1920"},{"id":1331518,"fileName":"067A1919.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fmg%2FmGgj24FAw4E59pOEtB__1719300722_8698503.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fmg%2FmGgj24FAw4E59pOEtB__1719300722_8698503.jpg&width=1920"},{"id":1354603778,"fileName":"067A1917.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fyy%2FYYTYiQpCk1Vbp5Mb7R__1719300718_9815003.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fyy%2FYYTYiQpCk1Vbp5Mb7R__1719300718_9815003.jpg&width=1920"},{"id":2091149271,"fileName":"067A1915.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fr1%2FR1vYfkSRskfBPWl6TC__1719300717_1392578.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fr1%2FR1vYfkSRskfBPWl6TC__1719300717_1392578.jpg&width=1920"},{"id":1912821534,"fileName":"067A1909.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fwc%2FwCRGt43zLZZLLa6TMz__1719300704_0814104.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fwc%2FwCRGt43zLZZLLa6TMz__1719300704_0814104.jpg&width=1920"},{"id":1580614059,"fileName":"067A1912.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fbr%2FbR9tiwzq1aQ8TexEiB__1719300704_1011222.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fbr%2FbR9tiwzq1aQ8TexEiB__1719300704_1011222.jpg&width=1920"},{"id":1667930021,"fileName":"067A1908.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Flz%2FlZOJs6l5qSJ5mf3fAZ__1719300703_0929116.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Flz%2FlZOJs6l5qSJ5mf3fAZ__1719300703_0929116.jpg&width=1920"},{"id":1002772968,"fileName":"067A1906.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Flv%2FlvpLlk4LYJoI7NDKu7__1719300695_4801907.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Flv%2FlvpLlk4LYJoI7NDKu7__1719300695_4801907.jpg&width=1920"},{"id":605327108,"fileName":"067A1905.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fzu%2FzumwwSuUqWfXm0q8c3__1719300690_8097985.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fzu%2FzumwwSuUqWfXm0q8c3__1719300690_8097985.jpg&width=1920"},{"id":343549136,"fileName":"067A1898.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fwp%2FWpqRtPWC0VP7zIEvHz__1719300686_8852018.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fwp%2FWpqRtPWC0VP7zIEvHz__1719300686_8852018.jpg&width=1920"},{"id":425280416,"fileName":"067A1897.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fi2%2FI2lOwqCRxsnyYIy3Fc__1719300678_6764687.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fi2%2FI2lOwqCRxsnyYIy3Fc__1719300678_6764687.jpg&width=1920"},{"id":28354564,"fileName":"067A1893.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fun%2FuNlel2Y06qsLzgjwaB__1719300678_8165956.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fun%2FuNlel2Y06qsLzgjwaB__1719300678_8165956.jpg&width=1920"},{"id":398074664,"fileName":"067A1891.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fz9%2Fz968mR9jWGhMIAZB6p__1719300671_8298463.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fz9%2Fz968mR9jWGhMIAZB6p__1719300671_8298463.jpg&width=1920"},{"id":470707111,"fileName":"067A1889.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2F32%2F32yameX1LBqig0BsZQ__1719300661_2384936.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2F32%2F32yameX1LBqig0BsZQ__1719300661_2384936.jpg&width=1920"},{"id":2131493199,"fileName":"067A1882.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fif%2FifgZz2LnlzFpibKjv1__1719300641_6148004.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fif%2FifgZz2LnlzFpibKjv1__1719300641_6148004.jpg&width=1920"},{"id":1697103948,"fileName":"067A1876.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fp6%2FP6BiE6LQTMo7WibsE8__1719300639_0601758.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fp6%2FP6BiE6LQTMo7WibsE8__1719300639_0601758.jpg&width=1920"},{"id":863290284,"fileName":"067A1875.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Ffk%2FFKbW2PJ0DOo1yHrH9P__1719300639_9725452.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Ffk%2FFKbW2PJ0DOo1yHrH9P__1719300639_9725452.jpg&width=1920"},{"id":1857044262,"fileName":"067A1872.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fn7%2FN7QPphhzz2S6OtOMy2__1719300634_5710170.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fn7%2FN7QPphhzz2S6OtOMy2__1719300634_5710170.jpg&width=1920"},{"id":577790267,"fileName":"067A1867.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fpo%2FpOfvcFkedO0mMiGU2f__1719300625_5805033.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fpo%2FpOfvcFkedO0mMiGU2f__1719300625_5805033.jpg&width=1920"},{"id":1242971329,"fileName":"067A1864.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2F8l%2F8LQDvxDLBl8N6oma3G__1719300623_4576741.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2F8l%2F8LQDvxDLBl8N6oma3G__1719300623_4576741.jpg&width=1920"},{"id":542354693,"fileName":"067A1863.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fv1%2FV1WXvKdSu7Vrc4Juxa__1719300620_1421480.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fv1%2FV1WXvKdSu7Vrc4Juxa__1719300620_1421480.jpg&width=1920"},{"id":1405434370,"fileName":"067A1862.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2F1q%2F1qJOy1oJVOMpitw993__1719300615_4059598.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2F1q%2F1qJOy1oJVOMpitw993__1719300615_4059598.jpg&width=1920"},{"id":821351694,"fileName":"067A1858.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fz8%2FZ8w1N2cQZGKm004QIC__1719300607_5987579.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fz8%2FZ8w1N2cQZGKm004QIC__1719300607_5987579.jpg&width=1920"},{"id":120657923,"fileName":"067A1856.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fxf%2FXFvgxwZzvuVhO9mBvT__1719300607_4739513.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fxf%2FXFvgxwZzvuVhO9mBvT__1719300607_4739513.jpg&width=1920"},{"id":538918453,"fileName":"067A1849.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2F56%2F56oZZroLIDsO1uv6uf__1719300592_6785646.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2F56%2F56oZZroLIDsO1uv6uf__1719300592_6785646.jpg&width=1920"},{"id":348350589,"fileName":"067A1853.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Ffy%2FFY3yqpQ7vKmkw16d7T__1719300593_1504172.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Ffy%2FFY3yqpQ7vKmkw16d7T__1719300593_1504172.jpg&width=1920"},{"id":1395634356,"fileName":"067A1848.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2F73%2F73jeYyrjdtb4p24g7Z__1719300584_9301366.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2F73%2F73jeYyrjdtb4p24g7Z__1719300584_9301366.jpg&width=1920"},{"id":202073526,"fileName":"067A1841.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2F0h%2F0HhB1iGNpt9ytzCzgh__1719300579_0726576.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2F0h%2F0HhB1iGNpt9ytzCzgh__1719300579_0726576.jpg&width=1920"},{"id":982864897,"fileName":"067A1840.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fus%2FUSnOD3bF5eUkt6z4xA__1719300576_2289692.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fus%2FUSnOD3bF5eUkt6z4xA__1719300576_2289692.jpg&width=1920"},{"id":1686652136,"fileName":"067A1839.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2F0n%2F0nLBrX7SmO96ApzDwV__1719300568_3448284.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2F0n%2F0nLBrX7SmO96ApzDwV__1719300568_3448284.jpg&width=1920"},{"id":1992832717,"fileName":"067A1835.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fdv%2FDvddxJbNVbUJJ4ouzA__1719300564_7546871.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fdv%2FDvddxJbNVbUJJ4ouzA__1719300564_7546871.jpg&width=1920"},{"id":1761383881,"fileName":"067A1828.jpg","originalFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileOrigs%2Fzy%2FzydQeaxIpDFTH8LtSn__1719300563_9468281.jpg","previewFileURL":"https://sukoa.px.media/gobackend/mediaserver?fp=%2FfileArchiv%2Fzy%2FzydQeaxIpDFTH8LtSn__1719300563_9468281.jpg&width=1920"}]}

        let url = `${this.apiUrl}/files?page=1&pageSize=500&sortBy=uploadDate&responseFields=["originalFileURL","previewFileURL","id","fileName", "fileSize", "width", "height", "variantStack", "keywords"]`

        // console.log(url)
        const hasCollection = (this.collections && this.collections.split(',').length === 2)
        const hasMultipleCollections = (this.collections && this.collections.split(',').length > 2)

        const hasKeyword = (this.keywords && this.keywords.split(',').length === 2)
        const hasMultipleKeywords = (this.keywords && this.keywords.split(',').length > 2)

        if ( (this.collections && this.keywords) ||
            hasMultipleCollections ||
            hasMultipleKeywords) {
            //if we have multiples the filter string needs to be set different
            // console.log('has multiple')

            url += `&filter={"filterType": "connectorOr","filters": [`

            if (this.collections) {
                this.collections = this.collections.split(',')
                // console.log('this.collections')
                // console.log(this.collections)
                this.collections.forEach( (el, idx, ar) => {
                    if (idx !== ar.length - 1){
                        url += `{"filterType": "collection","collectionID": "${el}"},`
                    }
                })
            }
            if (this.keywords) {
                this.keywords = this.keywords.split(',')
                // console.log('this.keywords')
                // console.log(this.keywords)
                this.keywords.forEach( (el, idx, ar) => {
                    if (idx !== ar.length - 1){
                        url += `{"filterType": "keyword", "exactMatch":"true", "term": "${el}"},`
                    }
                })
            }
            url = url.substring(0, url.length - 1); //remove last comma
            url += `],"inverted": false}`
        } else if (hasCollection) {
            // console.log('has ONLY ONE collection')
            this.collections = this.collections.split(',')
            url += `&filter={"filterType":"collection","collectionID":"${this.collections[0]}"}`
        } else if (hasKeyword) {
            // console.log('has ONLY ONE keyword')
            this.keywords = this.keywords.split(',')
            url += `&filter={"filterType":"keyword", "exactMatch":"true", "term":"${this.keywords[0]}"}`
        }
        // console.log(url)
        return url
    }
}

export default Pixxio;

